import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { useUpdateVisitMutation } from "src/api/services/visitApi";
import { UpdateVisitArgs } from "src/api/types";
import { MatchParam } from "src/constants/matches";

export const useUpdateVisit = () => {
  const [update] = useUpdateVisitMutation();
  const { visitId } = useParams<MatchParam<"VISIT_ID">>();

  const updateVisit = useCallback(
    async (data: UpdateVisitArgs) => {
      if (visitId == null) return null;

      await update({ slug: visitId, data });
    },
    [update, visitId]
  );

  return updateVisit;
};
